import { Button } from "antd";
import styles from "./game.module.css";
import { cards, specialCards, color } from "../Data/cards";
import { useState, useContext, useEffect } from "react";
import { db } from "../utils/firebase";
import { onValue, ref, set } from "firebase/database";
import { useParams, useNavigate } from "react-router-dom";
import { MyContext } from "../utils/utils";
import Setting from "./setting";
import { SettingFilled } from "@ant-design/icons";
import AllCard from "./allCard";
import MyCard from "./myCard";

const Game = () => {
  const { key } = useParams();
  const { currentUser, setCurrentUser } = useContext(MyContext);

  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };

  const [state, setState] = useState(null);
  useEffect(() => {
    onValue(ref(db, "rooms/" + key + "/state"), (snapshot) => {
      const val = snapshot.val();
      setState(val);
    });
  }, [db]);

  return (
    <div className={styles.body}>
      <div className={styles.gameboard}>
        <AllCard state={state} />
        {state == "PLAY" && <MyCard />}
      </div>

      <Setting visible={visible} setVisible={setVisible} />
      <Button
        style={{
          position: "absolute",
          top: "10px",
          right: "20px",
          fontSize: "20px",
        }}
        icon={<SettingFilled />}
        type="link"
        onClick={showDrawer}
      >
        설정
      </Button>
    </div>
  );
};

export default Game;
